import { transformCdnImageUrl } from "seneca-common/utils/images";

import { ContentSource, ImageAssetParameters } from "../types";

export function getModuleAssets(source: ContentSource): Array<string> {
  const urls = [source.imageAnswerURL, source.imageQuestionURL];
  source.imageURL && urls.push(source.imageURL);
  return urls;
}

export function transformModuleAssets(
  source: ContentSource,
  assetParams: ImageAssetParameters
): ContentSource {
  const mergeResult = {
    ...source,
    imageAnswerURL: transformCdnImageUrl(
      source.imageAnswerURL,
      assetParams.default
    )!,
    imageQuestionURL: transformCdnImageUrl(
      source.imageQuestionURL,
      assetParams.default
    )!
  };

  if (source.imageURL) {
    return {
      ...mergeResult,
      imageURL: transformCdnImageUrl(source.imageURL, assetParams.default)
    };
  }

  return mergeResult;
}
